module.exports = __webpack_public_path__ + "img/two1.89f1e0b6.png";